module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_bdtong_m.70c463969d706abf076b9b5ac8ed9b0c.png";